import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Enviar un correo con archivo adjunto (PDF u otro) usando Firebase Callable Function.
 * @param {Object} options
 * @param {string} options.to - Correo del destinatario
 * @param {string} options.subject - Asunto del email
 * @param {string} options.html - Cuerpo HTML
 * @param {string} [options.pdfBase64] - PDF en base64 (opcional)
 * @param {string} [options.fileName] - Nombre del archivo (opcional)
 */
export const enviarCorreoRecibo = async ({ to, subject, html, pdfBase64, fileName }) => {
  const functions = getFunctions();
  const sendEmail = httpsCallable(functions, 'enviarCorreoGenerico');

  const payload = {
    to,
    subject,
    html,
    pdfBase64,
    fileName
  };

  const res = await sendEmail(payload);
  return res.data;
};
